/**
 * Compare if the object value is Falsy, if it is, return the source value
 */
function orComparator(objValue: any, srcValue: any) {
  return objValue || srcValue;
}

export default orComparator;
